import React from "react";
import "./Text.css";

const Text = () => {
  return (
    <div className="text-container">
      <h1 className="future-text">
        Properties of <span className="green-text">Rajasree Townships</span>
      </h1>
    </div>
  );
};

export default Text;


